let appUrls = {
  api: '',
  mycompass: '',
  admin: ''
};

switch (window.location.hostname) {
    case 'localhost' || '127.0.0.1':
        // this is the local host name of your API
      appUrls.api = 'http://localhost:3252';
      appUrls.mycompass = 'http://localhost:8080';
      appUrls.admin = 'http://localhost:8081';
    break;
    
    case 'client':
      appUrls.api = 'http://node:3252'
    break
    
    case 'clientsdev.successionrg.com' || 'gallant-swartz-5f01fc.netlify.app':
      // this is the full url of your deployed dev API
      appUrls.api = 'https://srg-api-dev.herokuapp.com';
      appUrls.mycompass = 'https://clientsdev.successionrg.com';
      appUrls.admin = 'https://admindev.successionrg.com';
    break;
    
    case 'mycompass.successionresource.com' || 'keen-hopper-ea9e22.netlify.app':
      // this is the full url of the deployed live API
      appUrls.api = 'https://srg-api-prd.herokuapp.com';
      appUrls.mycompass = 'http://mycompass.successionresource.com';
      appUrls.admin = 'https://admin.successionresource.com';
    break;
}

export default appUrls;


// WEBPACK FOOTER //
// ./src/helpers/environment.js